<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      Disable Cameras
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col v-for="(cam, index) in availableChannels" :key="index" cols="6" class="d-flex align-center justify-center">
            <v-checkbox v-model="disabledChannelsPayload[cam.val]" :label="`Channel ${cam.label}`" @click="setSubmitState"></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    
    <v-card-actions>
      <v-btn
        color="primary"
        text
        @click="closeDialog"
      >
        CANCEL
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        :disabled="disableSubmit"
        @click="updateDisabledCameras"
      >
        SAVE
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { Logger } from "aws-amplify";
const logger = new Logger("Disable Cameras");

export default {
  name: 'DisableCamera',
  props: {
    action: {
      type: Object,
      required: true
    },
    channels: {
      type: Array,
      required: true
    },
    disabledCameras: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      disabledChannelsPayload: {},
      initDisabledChannelsState: {},
      disableSubmit: false
    }
  },
  computed: {
    availableChannels() {
      const channels = this.channels.map(item => (
        {
          label: item.number[0],
          val: item.number[0]
        } 
      ));

      return channels;
    },
    disabledChannels() {
      return this.action.action[0].disableCameras
    },
    
  },
  watch: {
    visible(val) {
      if(val) {
        logger.info('visible')
        this.disabledChannelsPayload = JSON.parse(JSON.stringify(this.initDisabledChannelsState))
        logger.info('this.disabledChannelsPayload', this.disabledChannelsPayload)
        this.$emit('refreshComp')
      }
    }
  },
  beforeMount() {
    this.parseDisabledChannels()
  },
  methods: {
    setSubmitState() {
      return new Promise((resolve, reject) => {
        try {
          for (const key in this.disabledChannelsPayload) {
            logger.info(this.disabledChannelsPayload[key])
            if (this.disabledChannelsPayload[key] == true) {
              this.disableSubmit = false
              return
            }
            this.disableSubmit = true
          }

          resolve(true)
        } catch {
          reject(false)
        }
      })
    },
    parseDisabledChannels() {
      return new Promise((resolve, reject) => {
        try {
          logger.info('parseDisabledChannels')
          this.availableChannels.forEach(channel => {
            this.disabledChannelsPayload[channel.val] = false
          })
          this.disabledChannels.forEach(channels => {
            logger.info('channel info', channels)
            if(channels && channels.hasOwnProperty('cameraChannel') && channels.cameraChannel.length > 0) {
              channels.cameraChannel.forEach(channel => {
                this.disabledChannelsPayload[channel] = true
              })
              
            }
          })

          this.initDisabledChannelsState = JSON.parse(JSON.stringify(this.disabledChannelsPayload))

          resolve(true)
        } catch {
          reject(false)
        }
      })
      
      
    },
    updateDisabledCameras() {
      this.$emit('updateDisabledCameras', this.disabledChannelsPayload)
      this.$emit('closeDialog');
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  },
  
}
</script>